/**
 * @file This file should hold basic values that should have consistency across the project
 * and that are needed in more than one place.
 */

/**
 * A general wait time in milliseconds when using 'setTimeout' to wait for content to update
 * before performing an action.
 */
const contentWaitTimeout = 500;

/**
 * The time in milliseconds to debounce a function that might rapidly repeat itself otherwise.
 * Uses a debounce library.
 * @see https://www.npmjs.com/package/debounce
 */
const debounceTimeout = 200;

export { contentWaitTimeout, debounceTimeout };
